/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Push sold-out products to the bottom of collection page grids.
 * Items are tagged server-side with data-available (see snippets/product-item.liquid).
 * Re-runs after AJAX filtering/sorting/pagination via the theme's "theme:loading:end" event.
 */
(function() {
  function sortCollectionProducts() {
    if (!window.theme || window.theme.pageType !== 'collection') return;

    document.querySelectorAll('.product-list').forEach(function(list) {
      // Carousel lists (e.g. recommendations) are managed by Flickity; reordering would break them
      if (list.classList.contains('flickity-enabled')) return;

      var items = Array.prototype.slice.call(list.querySelectorAll('.product-item'));
      if (items.length < 2) return;

      var soldOut = items.filter(function(item) {
        return item.getAttribute('data-available') === 'false';
      });
      if (soldOut.length === 0 || soldOut.length === items.length) return;

      // Skip if sold-out items are already all at the end
      var firstSoldOutIndex = items.indexOf(soldOut[0]);
      if (items.length - firstSoldOutIndex === soldOut.length) return;

      soldOut.forEach(function(item) { list.appendChild(item); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortCollectionProducts);
  } else {
    sortCollectionProducts();
  }

  // Fired by the theme after AJAX content (filters, sorting, pagination) has been swapped in
  document.addEventListener('theme:loading:end', function() {
    requestAnimationFrame(sortCollectionProducts);
  });
})();

/**
 * Bat Bundle Builder — offers bat services (knocking-in, grips, toe guards, ...) in a popup
 * when a cricket bat is added to the cart from a product page.
 *
 * Bat products are detected server-side: snippets/product-buy-buttons.liquid adds a
 * [data-tcs-bat-services] marker inside the product form when product.type is "Cricket Bat".
 *
 * NOTE: variant IDs and prices below must be kept in sync with the "Bat Services" products
 * in the Shopify admin. Prices are display-only; the cart always charges the real variant price.
 */
(function() {
  var SERVICES = [
    { vid: 48021864120546, title: 'PVC Knocking - TCS Bat', price: 40 },
    { vid: 48021864153314, title: 'PVC Knocking - Outside Bat', price: 50 },
    { vid: 48021864186082, title: 'Leadwood Knocking - TCS Bat', price: 60 },
    { vid: 48021864218850, title: 'Leadwood Knocking - Outside Bat', price: 70 },
    { vid: 48021845180642, title: 'Linseed Wax Coat', price: 5 },
    { vid: 48021845213410, title: 'Rubber Toe Guard', price: 20 },
    { vid: 48021845278946, title: 'Epoxy Glue Toe Guard', price: 20 },
    { vid: 48021845311714, title: 'Scuff Sheet', price: 10 },
    { vid: 48021845344482, title: 'Bat Grip', price: 7 },
    { vid: 48021845377250, title: 'Laser Engraving', price: 10 },
    { vid: 48021845410018, title: 'Weight Reduction', price: 50 },
    { vid: 48021845442786, title: 'Toe Binding / Threading', price: 35 },
    { vid: 48021860417762, title: 'Handle Replacement', price: 65 },
    { vid: 48021865890018, title: 'Two-Way Shipping Label', price: 30 }
  ];

  var submitting = false;

  function el(tag, styles, text) {
    var node = document.createElement(tag);
    if (styles) node.style.cssText = styles;
    if (text) node.textContent = text;
    return node;
  }

  function showServicePopup(variantId, quantity) {
    var existing = document.getElementById('bat-bundle-modal');
    if (existing) existing.remove();

    var overlay = el('div', 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;display:flex;align-items:center;justify-content:center;');
    overlay.id = 'bat-bundle-modal';

    var dialog = el('div', 'background:#fff;border-radius:12px;width:90%;max-width:520px;max-height:90vh;overflow-y:auto;padding:24px;box-shadow:0 8px 32px rgba(0,0,0,0.2);');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Add Bat Services');
    dialog.tabIndex = -1;

    var header = el('div', 'display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;');
    header.appendChild(el('h2', 'margin:0;font-size:20px;color:#1e2d7d;', 'Add Bat Services'));
    var closeBtn = el('button', 'cursor:pointer;font-size:24px;color:#999;line-height:1;padding:4px 8px;background:none;border:none;', '×');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'No services, just add the bat');
    header.appendChild(closeBtn);
    dialog.appendChild(header);

    dialog.appendChild(el('p', 'margin:0 0 12px;font-size:14px;color:#666;', 'Enhance your bat with these services. Check the ones you want:'));

    var itemsWrap = el('div');
    SERVICES.forEach(function(service) {
      var label = el('label', 'display:flex;align-items:center;gap:10px;padding:10px;border:1px solid #e0e0e0;border-radius:8px;cursor:pointer;margin-bottom:6px;background:#fff;');
      var checkbox = el('input', 'width:18px;height:18px;accent-color:#1e2d7d;flex-shrink:0;');
      checkbox.type = 'checkbox';
      checkbox.className = 'bb-checkbox';
      checkbox.dataset.vid = service.vid;
      checkbox.dataset.price = service.price;
      label.appendChild(checkbox);
      var titleWrap = el('div', 'flex:1;');
      titleWrap.appendChild(el('div', 'font-weight:600;font-size:14px;color:#1a1a1a;', service.title));
      label.appendChild(titleWrap);
      label.appendChild(el('div', 'font-weight:700;font-size:15px;color:#1e2d7d;', '+$' + service.price));
      itemsWrap.appendChild(label);
    });
    dialog.appendChild(itemsWrap);

    var footer = el('div', 'display:flex;align-items:center;justify-content:space-between;margin-top:16px;padding-top:16px;border-top:2px solid #e0e0e0;');
    var totalWrap = el('div', 'font-size:16px;font-weight:600;', 'Services total: ');
    var totalValue = el('span', 'color:#1e2d7d;font-size:20px;', '$0');
    totalWrap.appendChild(totalValue);
    footer.appendChild(totalWrap);

    var buttonsWrap = el('div', 'display:flex;gap:8px;');
    var skipBtn = el('button', 'background:#eee;color:#333;border:none;padding:10px 20px;border-radius:8px;cursor:pointer;font-weight:600;font-size:14px;', 'Skip');
    skipBtn.type = 'button';
    var addBtn = el('button', 'background:#1e2d7d;color:#fff;border:none;padding:10px 24px;border-radius:8px;cursor:pointer;font-weight:600;font-size:14px;', 'Add to Cart');
    addBtn.type = 'button';
    buttonsWrap.appendChild(skipBtn);
    buttonsWrap.appendChild(addBtn);
    footer.appendChild(buttonsWrap);
    dialog.appendChild(footer);

    var message = el('div', 'margin-top:8px;padding:8px;border-radius:6px;background:#f8d7da;color:#721c24;display:none;');
    dialog.appendChild(message);

    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    dialog.focus();

    dialog.addEventListener('change', function(event) {
      if (!event.target.classList.contains('bb-checkbox')) return;
      var total = 0;
      dialog.querySelectorAll('.bb-checkbox:checked').forEach(function(checkbox) {
        total += parseFloat(checkbox.dataset.price);
      });
      totalValue.textContent = '$' + total;
    });

    function onKeydown(event) {
      if (event.key === 'Escape') completeAdd([]);
    }
    document.addEventListener('keydown', onKeydown);

    // Every path out of the popup still adds the bat — the customer already clicked "Add to Cart".
    function completeAdd(serviceItems) {
      if (submitting) return;
      submitting = true;
      addBtn.textContent = 'Adding...';
      addBtn.disabled = true;
      skipBtn.disabled = true;
      closeBtn.disabled = true;

      var items = [{ id: variantId, quantity: quantity }].concat(serviceItems);

      fetch(window.routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(response) {
        if (!response.ok) {
          return response.json().catch(function() { return {}; }).then(function(body) {
            throw new Error(body.description || body.message || ('Request failed (' + response.status + ')'));
          });
        }
        document.removeEventListener('keydown', onKeydown);
        window.location.href = window.routes.cartUrl;
      }).catch(function(error) {
        submitting = false;
        message.textContent = 'Could not add to cart: ' + error.message;
        message.style.display = 'block';
        addBtn.textContent = 'Add to Cart';
        addBtn.disabled = false;
        skipBtn.disabled = false;
        closeBtn.disabled = false;
      });
    }

    function selectedServices() {
      var services = [];
      dialog.querySelectorAll('.bb-checkbox:checked').forEach(function(checkbox) {
        services.push({ id: parseInt(checkbox.dataset.vid, 10), quantity: 1 });
      });
      return services;
    }

    addBtn.addEventListener('click', function() { completeAdd(selectedServices()); });
    skipBtn.addEventListener('click', function() { completeAdd([]); });
    closeBtn.addEventListener('click', function() { completeAdd([]); });
    overlay.addEventListener('click', function(event) {
      if (event.target === overlay) completeAdd([]);
    });
  }

  // Capture-phase listener runs before the theme's own delegated submit handler,
  // so stopPropagation() here prevents the theme's AJAX add-to-cart from also firing.
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (form.tagName !== 'FORM') return;
    if (form.action.indexOf('/cart/add') === -1) return;
    if (!form.querySelector('[data-tcs-bat-services]')) return;
    if (submitting) { event.preventDefault(); event.stopPropagation(); return; }

    var formData = new FormData(form);
    var variantId = parseInt(formData.get('id'), 10);
    if (!variantId) return; // let the theme handle it (and surface its own error)

    event.preventDefault();
    event.stopPropagation();

    var quantity = parseInt(formData.get('quantity') || '1', 10) || 1;
    showServicePopup(variantId, quantity);
  }, true);
})();
